export default [
  {
    "id": 1,
    "label": "Brûleurs",
    "contient_fluide": false,
    "types_interventions": [
      { "label": "Entretien / Nettoyage brûleur", "manipulation_fluide": false },
      { "label": "Réglage combustion", "manipulation_fluide": false },
      { "label": "Dépannage allumeur / électrodes", "manipulation_fluide": false },
      { "label": "Remplacement gicleur", "manipulation_fluide": false },
      { "label": "Remplacement moteur / ventilateur", "manipulation_fluide": false },
      { "label": "Remplacement boîtier de contrôle", "manipulation_fluide": false },
      { "label": "Dépannage alimentation fioul", "manipulation_fluide": false },
      { "label": "Réglage air/fioul", "manipulation_fluide": false }
    ]
  },

  {
    "id": 2,
    "label": "Chaudières",
    "contient_fluide": false,
    "types_interventions": [
      { "label": "Entretien annuel", "manipulation_fluide": false },
      { "label": "Dépannage chaudière", "manipulation_fluide": false },
      { "label": "Détection de fuite (eau, gaz)", "manipulation_fluide": false },
      { "label": "Purge / Remise en pression", "manipulation_fluide": false },
      { "label": "Désembouage circuit chauffage", "manipulation_fluide": false },
      { "label": "Remplacement vase d'expansion", "manipulation_fluide": false },
      { "label": "Remplacement circulateur", "manipulation_fluide": false },
      { "label": "Remplacement organe de sécurité", "manipulation_fluide": false },
      { "label": "Remplacement carte électronique", "manipulation_fluide": false },
      { "label": "Mise en service", "manipulation_fluide": false }
    ]
  },

  {
    "id": 3,
    "label": "Chauffe-bains",
    "contient_fluide": false,
    "types_interventions": [
      { "label": "Entretien / Détartrage", "manipulation_fluide": false },
      { "label": "Dépannage brûleur / allumeur", "manipulation_fluide": false },
      { "label": "Remplacement échangeur", "manipulation_fluide": false },
      { "label": "Remplacement membrane / soupape", "manipulation_fluide": false },
      { "label": "Remplacement régulation / carte", "manipulation_fluide": false },
      { "label": "Réglage débit gaz / eau", "manipulation_fluide": false }
    ]
  },

  {
    "id": 4,
    "label": "Clim - Unités extérieures",
    "contient_fluide": true,
    "types_interventions": [
      { "label": "Dépannage unité extérieure", "manipulation_fluide": false },
      { "label": "Nettoyage condenseur", "manipulation_fluide": false },
      { "label": "Diagnostic compresseur", "manipulation_fluide": false },
      { "label": "Contrôle étanchéité circuit", "manipulation_fluide": true },
      { "label": "Recherche de fuite", "manipulation_fluide": true },
      { "label": "Récupération du fluide", "manipulation_fluide": true },
      { "label": "Recharge / Complément fluide", "manipulation_fluide": true },
      { "label": "Remplacement compresseur", "manipulation_fluide": true },
      { "label": "Remplacement détendeur électronique", "manipulation_fluide": true },
      { "label": "Remplacement ventilateur", "manipulation_fluide": false },
      { "label": "Mise en service", "manipulation_fluide": true },
      { "label": "Brasure / soudure sur circuit", "manipulation_fluide": true }
    ]
  },

  {
    "id": 5,
    "label": "Clim - Unités intérieures",
    "contient_fluide": true,
    "types_interventions": [
      { "label": "Nettoyage complet unité intérieure", "manipulation_fluide": false },
      { "label": "Dépannage électronique / carte", "manipulation_fluide": false },
      { "label": "Dépannage ventilation / moteur", "manipulation_fluide": false },
      { "label": "Recherche fuite UI", "manipulation_fluide": true },
      { "label": "Réseaux condensats / débouchage", "manipulation_fluide": false },
      { "label": "Remplacement carte / sonde", "manipulation_fluide": false },
      { "label": "Remplacement évaporateur", "manipulation_fluide": true },
      { "label": "Mise en service (côté UI)", "manipulation_fluide": true }
    ]
  },

  {
    "id": 6,
    "label": "PAC - Unités extérieures",
    "contient_fluide": true,
    "types_interventions": [
      { "label": "Dépannage unité extérieure PAC", "manipulation_fluide": false },
      { "label": "Nettoyage échangeur", "manipulation_fluide": false },
      { "label": "Contrôle compresseur / cycle frigorifique", "manipulation_fluide": false },
      { "label": "Recherche de fuite", "manipulation_fluide": true },
      { "label": "Complément / Recharge fluide", "manipulation_fluide": true },
      { "label": "Récupération fluide", "manipulation_fluide": true },
      { "label": "Remplacement compresseur", "manipulation_fluide": true },
      { "label": "Remplacement ventilateur", "manipulation_fluide": false },
      { "label": "Brasure / Raccordement frigorifique", "manipulation_fluide": true },
      { "label": "Mise en service", "manipulation_fluide": true }
    ]
  },

  {
    "id": 7,
    "label": "PAC - Unités intérieures",
    "contient_fluide": true,
    "types_interventions": [
      { "label": "Dépannage module hydraulique", "manipulation_fluide": false },
      { "label": "Purge / Remise en pression circuit", "manipulation_fluide": false },
      { "label": "Détection fuite UI", "manipulation_fluide": true },
      { "label": "Purge / Nettoyage filtre Y", "manipulation_fluide": false },
      { "label": "Remplacement circulateur intégré", "manipulation_fluide": false },
      { "label": "Remplacement échangeur plaques", "manipulation_fluide": false },
      { "label": "Remplacement carte électronique", "manipulation_fluide": false },
      { "label": "Mise en service module intérieur", "manipulation_fluide": true }
    ]
  },

  {
    "id": 8,
    "label": "Régulations",
    "contient_fluide": false,
    "types_interventions": [
      { "label": "Dépannage sonde (air, eau, ballon, extérieure…)", "manipulation_fluide": false },
      { "label": "Remplacement carte de régulation", "manipulation_fluide": false },
      { "label": "Paramétrage régulation", "manipulation_fluide": false },
      { "label": "Re-calibrage sondes", "manipulation_fluide": false },
      { "label": "Dépannage thermostat / commande murale", "manipulation_fluide": false },
      { "label": "Mise à jour / restauration paramètres", "manipulation_fluide": false }
    ]
  },

  {
    "id": 9,
    "label": "Chauffe-eau thermodynamique",
    "contient_fluide": true,
    "types_interventions": [
      { "label": "Entretien / Nettoyage aérothermie", "manipulation_fluide": false },
      { "label": "Dépannage compresseur / cycle frigorifique", "manipulation_fluide": false },
      { "label": "Dépannage résistance / électronique", "manipulation_fluide": false },
      { "label": "Recherche de fuite", "manipulation_fluide": true },
      { "label": "Complément / Recharge fluide", "manipulation_fluide": true },
      { "label": "Récupération du fluide", "manipulation_fluide": true },
      { "label": "Remplacement ventilateur / carte", "manipulation_fluide": false },
      { "label": "Mise en service", "manipulation_fluide": true }
    ]
  }
]
